import useSystemTheme, { SystemTheme } from "use-system-theme";
import { CustomTheme } from "../../@types/styled-components";
import { theme as _theme } from "../../config/theme";
import { useCallback, useMemo, useState } from "react";
import { getThemeMode, setThemeMode as _setThemeMode } from "../../services/localStorageServices";

export function useTheme() {
  const currentSystemThemeMode = useSystemTheme();

  const [ themeMode, setThemeMode ] = useState<SystemTheme>( getThemeMode() as SystemTheme ?? currentSystemThemeMode );
  const [ theme, setTheme ] = useState<CustomTheme>( _theme[ themeMode ]);

  const changeTheme = useCallback(() => {
    const themeModes = {
      light: "dark",
      dark: "light",
    };

    const newThemeMode = themeModes[ themeMode ] as SystemTheme;

    const newTheme = _theme[ newThemeMode ];

    setThemeMode( newThemeMode );
    setTheme( newTheme );

    _setThemeMode( newThemeMode );
  }, [ themeMode ]);

  return useMemo(() => ({
    theme,
    themeMode,
    changeTheme,
  }), [
    theme,
    themeMode,
    changeTheme,
  ]);
};
